module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av715-ab6cce446c7d33dd6ae6aa51317b62e1.jpg";